const config = {prefix: '/sounds/'};

export default config;
